export const ENV = {
    localhost: 'localhost',
    sit: 'sit',
    int: 'int',
    stag: 'stag',
    prod: 'prod'
}